<template>
  <div
    class="button-wrapper"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
    @focus="showTooltip"
    @blur="hideTooltip"
  >
    <button
      class="custom-button"
      :disabled="disabled"
      :aria-disabled="disabled"
      @click="handleClick"
    >
      <div class="flex justify-center items-center gap-2">
        <feather-icon v-if="icon" :icon="icon" svgClasses="h-4 w-4" />
        <span>{{ label }}</span>
      </div>
    </button>
    <div v-if="tooltipVisible && disabled" class="tooltip">
      <span class="tooltip-content">{{ disabledReason }}</span>
      <span class="tooltip-arrow"></span>
    </div>
  </div>
</template>

<script>
import ColorMixin from "@/mixins/ColorMixin.js";

export default {
  mixins: [ColorMixin],
  props: {
    icon: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabledReason: {
      type: String,
      required: false,
      default: "このボタンは無効です",
    },
  },
  data() {
    return {
      tooltipVisible: false,
    };
  },
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit("click");
      }
    },
    showTooltip() {
      if (this.disabled) {
        this.tooltipVisible = true;
      }
    },
    hideTooltip() {
      this.tooltipVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.button-wrapper {
  position: relative;
  display: inline-block;

  .tooltip {
    position: absolute;
    top: calc(-100% - 10px); /* ボタン上部にツールチップを配置 */
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 0.5rem 0.75rem;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;
    pointer-events: none;

    .tooltip-content {
      text-align: center;
    }

    .tooltip-arrow {
      position: absolute;
      bottom: -6px; /* 矢印をツールチップの下に配置 */
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid rgba(0, 0, 0, 0.7); /* 矢印の色をツールチップと一致 */
    }
  }
}

.custom-button {
  height: 2.5rem;
  padding: var(--Margin-m-15, 0.375rem) 1.125rem;
  border: 1px solid #3498db;
  border-radius: 8px;
  background-color: #fff;
  color: #039be5;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: #039be5;
    color: #fff;
  }

  &:disabled {
    background-color: #f5f5f5;
    color: #9e9e9e;
    border-color: #bdbdbd;
    cursor: not-allowed;
  }
}
</style> 